import React, { useEffect } from "react";
import SectionLabel from "@components/common/SectionLabel";
import LinkButton from "@components/common/LinkButton";
import FeaturedPlansBannersItemList from "./FeaturedPlansBannersItemList";

import useFetchJSONData from "@hooks/useFetchJSONData";

import "./FeaturedPlansSection.scss";

export default function FeaturedPlansSection() {
  const { data, loading, error } = useFetchJSONData(
    "home-featured-plans-section"
  );

  const lang = window.THREE_REACT_APP_GLOBAL.language;
  const sectionLabel = lang === "tc" ? "精選月費計劃" : "Featured Plans";

  if (loading || error || !data) return null;

  const { linkButtons, banners } = data;

  return (
    <section className="section-featured-plans" id="section-featured-plans">
      <div className="section-featured-plans-container container">
        <div className="section-featured-plans-header-container">
          <SectionLabel
            className="section-featured-plans-label"
            text={sectionLabel}
          />

          {linkButtons !== null && linkButtons.length > 0 && (
            <div className="link-button-group-container">
              {linkButtons.map((linkButton, i) => (
                <LinkButton
                  key={`link-button-${i + 1}`}
                  linkButton={linkButton}
                />
              ))}
            </div>
          )}
        </div>

        <FeaturedPlansBannersItemList banners={banners} />
      </div>
    </section>
  );
}
